import axios from "axios";
import instance from "./axios";
import baseUrl from "@/env";

const SUBJECTIVE_SOLVE_URL = `${baseUrl}/ai/test/subjective/solve`;
const OBJECTIVE_CHAT_URL = `${baseUrl}/ai/test/objective/chat`;
const OBJECTIVE_EXTENSION_URL = `${baseUrl}/ai/test/objective/extension`;
const OBJECTIVE_STREAM_URL = `${baseUrl}/ai/test/objective/stream`;

const solveClient = axios.create({
  timeout: 120000,
  withCredentials: false
});

export async function solveWithQuestion({ question, file }) {
  const formData = new FormData();
  formData.append("question", question);
  formData.append("file", file);

  const response = await solveClient.post(SUBJECTIVE_SOLVE_URL, formData);
  return response.data;
}

export async function solveQuestionOnly({ question }) {
  const formData = new FormData();
  formData.append("question", question);

  const response = await solveClient.post(SUBJECTIVE_SOLVE_URL, formData);
  return response.data;
}

export async function solveQuestionByDeepSeek({ questionText }) {
  const response = await instance.post(OBJECTIVE_CHAT_URL, { questionText });
  return response.data;
}

export async function solveObjectiveExtensionByDeepSeek({
  questionText,
  analysisText
}) {
  const response = await instance.post(OBJECTIVE_EXTENSION_URL, {
    questionText,
    analysisText
  });
  return response.data;
}

export function buildDeepSeekStreamUrl(questionText) {
  const encodedQuestionText = encodeURIComponent((questionText || "").trim());
  const t = Date.now();
  return `${OBJECTIVE_STREAM_URL}?questionText=${encodedQuestionText}&t=${t}`;
}
